<section class="curation-status-class">
  <div class="curation-status-background {{curationStatus}}"></div>
  <div class="curation-status-oval {{curationStatus}}"></div>
  <span class="curation-status-approved-title  {{curationStatus}}">{{status}}</span>
  <span class="curation-status-revision-name">{{revisionName}}</span>
  <span class="curation-status-title-label">{{titleLabel}}</span>
  <span class="curation-status-title-text">{{titleText}}</span>
  <span class="icon__alert fs7"
        *ngIf="curationStatus === 'rejected' &&
               curationItem['opinion']['rejectMessage']"
        genTooltip
        [tooltipPosition]="'BOTTOM'"
        [tooltipShow]="true"
        [tooltipHtml]="'<style>span{white-space: pre-wrap;}</style>'+
                       '<span><b>Rejection note</b> <br/>'+
                       curationItem['opinion']['rejectMessage']+
                       '</span>'"
  ></span>
  <div *ngIf="!readOnlyUserMode" class="curation-status-workflow">
    <gen-workflow-bar></gen-workflow-bar>
  </div>
  <gen-history class="curation-status-history"
               [itemTypeText]="'revision'"
               [dropdownTitle]="'Other revisions'"
               [columnsToDisplay]="revisionsColumns"
               [historyData]="revisionsData$"
               [currentRevisionId]="currentRevisionId"
               [revisionLastUpdatedDate] = "revisionLastUpdatedDate"
               (historyRowClick)="historyRowClick($event)">
  </gen-history>
</section>
